import React from "react";
import SectionHeading from "./sectionHeading";
import { useMediaQuery } from "react-responsive";

export default function InformationPanel({ content }) {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  function conditionsList(columnIndex, columnClassName, listItem, itemDot) {
    return (
      <div className={columnClassName}>
        {listItem.map(
          (item, index) =>
            ((columnIndex === 1 && index % 2 === 0) || (columnIndex === 2 && index % 2 === 1) || columnIndex === 0) && (
              <div key={`item_${index}`} className="item">
                <div className={itemDot} />
                <span>{item.text}</span>
              </div>
            )
        )}
      </div>
    );
  }

  return (
    <div id="informationPanel">
      <div className="simpleTextPanel">
        <SectionHeading title={content.simpleTextPanel.title} subtitle={content.simpleTextPanel.subtitle} />
        <div className="text" dangerouslySetInnerHTML={{ __html: content.simpleTextPanel.text }} />
      </div>
      <div className="conditionsList">
        <SectionHeading title={content.conditionsList.title} subtitle={content.conditionsList.subtitle} />
        <div className="conditionsContainer">
          <div className="conditionsTop">
            <div
              className="descriptionTop"
              dangerouslySetInnerHTML={{ __html: content.conditionsList.descriptionTop }}
            />
            <div className="listItemTop">
              {isMobile ? (
                conditionsList(0, "columnOne", content.conditionsList.listItemTop, "itemTopDot")
              ) : (
                <>
                  {conditionsList(1, "columnOne", content.conditionsList.listItemTop, "itemTopDot")}
                  {conditionsList(2, "columnTwo", content.conditionsList.listItemTop, "itemTopDot")}
                </>
              )}
            </div>
          </div>
          <div className="conditionsBottom">
            <div
              className="descriptionBottom"
              dangerouslySetInnerHTML={{ __html: content.conditionsList.descriptionBottom }}
            />
            <div className="listItemBottom">
              {conditionsList(1, "columnOne", content.conditionsList.listItemBottom, "itemBottomDot")}
              {conditionsList(2, "columnTwo", content.conditionsList.listItemBottom, "itemBottomDot")}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
